module.exports = __webpack_public_path__ + "media/images/icons/club_bi_desktop-6af712ca29cee07abfbbe82e727ba52e.svg";